const moveWithinArray = (arr, from, to) => {
  if (from === to) {
    return arr;
  }
  const item = arr.splice(from, 1)[0];
  arr.splice(to, 0, item);
  return arr;
};

const moveAfterItem = (arr, from, after) => {
  // Why would you move an item after itself? It'll be in the same place.
  if (from === after) {
    return arr;
  }
  // To put an item after another, it should be the next index.
  // But if the item is before the one it's being moved after,
  // it needs to compensate for its own spot disappearing by being the same index.
  if (from > after) {
    ++after;
  }
  return moveWithinArray(arr, from, after);
};

const moveAfterItemByItem = (arr, item, afterItem) => {
  const fromIndex = arr.indexOf(item);
  const afterIndex = arr.indexOf(afterItem);
  if (fromIndex === -1 || afterIndex === -1) {
    return arr;
  }
  return moveAfterItem(arr, fromIndex, afterIndex);
};

const isEmptyObject = (obj) => {
  for (let i in obj) {
    return false;
  }
  return true;
};

const findInObj = (obj, conditionFunction) => {
  // TO DO: Generalise function to take any array methods, e.g. some, filter

  // Iterating over the object values allows us to pass in a function that uses the same syntax as Array.find()
  const objPropsArray = Object.values(obj);
  return objPropsArray.find((prop) => {
    return conditionFunction(prop);
  });
};

/**
 * Converts a value to a number, returning a fallback if parsing fails
 * @param {number|string} value - The value to convert to a number
 * @param {number} fallback - Value to return if parsing fails
 * @returns {number} The parsed number or fallback value
 */
const asNumber = (value, fallback = 0) => {
  const parsed = Number.parseFloat(value);
  return Number.isNaN(parsed) ? fallback : parsed;
};

/**
 * Formats a string template by replacing {n} placeholders with provided parameters
 * @param {string} template - The string template containing {n} placeholders
 * @param {...*} params - Values to insert into the template
 * @returns {string} The formatted string with placeholders replaced by parameters
 */
const formatString = (template, ...params) => {
  const length = params.length;

  return template.replace(/{(\d+)}/g, (match, index) =>
    index >= length ? match : `${params[index]}`
  );
};

/**
 * Checks if a value is defined (not undefined)
 * @param {*} value - The value to check
 * @returns {boolean} True if the value is defined, false otherwise
 */
const isDefined = (value) => {
  return value !== undefined;
};

const isElement = (node) => {
  return node instanceof Node && node.nodeType === Node.ELEMENT_NODE;
};

const handleize = (value) => {
  return value.toLowerCase().replace(/ /g, '-');
};

const removeParams = (keys) => {
  const url = new URL(location.href);
  keys.forEach(key => url.searchParams.delete(key));
  history.replaceState(null, '', url);
};

const convertObjectToFormData = (object) => {
  const formData = new FormData();
  Object.entries(object).forEach(([key, value]) => {
    formData.append(key, value);
  });
  return formData;
};

const convertFormDataToObject = (formData) => {
  const object = {};
  formData.forEach((value, key) => {
    if (['true', 'false'].includes(value)) {
      object[key] = value === 'true';
      return;
    }
    object[key] = value;
  });
  return object;
};

const wait = ms => new Promise((resolve, reject) => setTimeout(resolve, ms));

export {
  moveWithinArray,
  moveAfterItem,
  moveAfterItemByItem,
  isEmptyObject,
  findInObj,
  asNumber,
  formatString,
  isDefined,
  isElement,
  handleize,
  removeParams,
  convertObjectToFormData,
  convertFormDataToObject,
  wait,
};
